import React, { Component, ReactNode } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ErrorNotificationContext } from "./contexts/ErrorNotificationContext";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  errorMessage: string | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static contextType = ErrorNotificationContext;

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, errorMessage: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);

    const context = this.context as any;
    if (context && context.addError) {
      context.addError(
        error.message || 'An unexpected error occurred',
        `boundary-${Date.now()}`
      );
    }

    this.setState({ hasError: false });
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
